import {createSignalRContext} from "react-signalr";

export const SignalRContext = createSignalRContext();